export default __webpack_public_path__ + "static/9-a513c5c878d0c077fa121c413203a326.png";